function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GetItContext } from "../../base/provider/GetItContext";
import { NodesUtil } from "../NodesUtil";
import { useSignal } from "@preact/signals-react";
import { FotClient } from "imagica-corekit/dist/base/api/FotClient";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { get, isEmpty } from "lodash";
import mapboxgl from "mapbox-gl";
import { useContext, useRef } from "react";
export var MapViewBloc = /*#__PURE__*/function () {
  function MapViewBloc(reMapboxgl) {
    _classCallCheck(this, MapViewBloc);
    _defineProperty(this, "getIt", useContext(GetItContext));
    _defineProperty(this, "mapboxgl", void 0);
    _defineProperty(this, "brainClient", this.getIt(FotClient));
    _defineProperty(this, "map", useSignal(null));
    _defineProperty(this, "id", useSignal(""));
    _defineProperty(this, "marker", useSignal({}));
    _defineProperty(this, "mapMarkerRef", useRef(null));
    _defineProperty(this, "isFirstLoad", useSignal(true));
    _defineProperty(this, "statusList", useSignal([]));
    _defineProperty(this, "locationNoneList", useSignal([]));
    _defineProperty(this, "mapList", useSignal([]));
    // 地图中的marker列表数据
    _defineProperty(this, "photoList", useSignal([]));
    // 地图中的marker列表数据
    _defineProperty(this, "isMultInput", useSignal(false));
    _defineProperty(this, "mapLoading", useSignal(false));
    _defineProperty(this, "markerIcon", "https://dopniceu5am9m.cloudfront.net/static/blocks/icon/map_marker.png");
    _defineProperty(this, "tipError", useSignal({}));
    this.mapboxgl = reMapboxgl;
  }
  _createClass(MapViewBloc, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id, results) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.initMap(id, [-115.1765067, 36.1129455]); // 默认中心点经纬度
              this.handleInputResults(results);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "reloadMap",
    value: function reloadMap(results) {
      this.handleInputResults(results);
    }
  }, {
    key: "initMap",
    value: function initMap(id, coordinates) {
      var locationLatLng = coordinates || [-115.1765067, 36.1129455];
      mapboxgl.accessToken = settings.mapKey;
      this.id.value = id;
      this.map.value = new mapboxgl.Map({
        container: id,
        style: "mapbox://styles/mapbox/light-v9",
        center: locationLatLng,
        zoom: 12
      });
    }
  }, {
    key: "resetData",
    value: function resetData() {
      this.mapList.value = [];
      this.statusList.value = [];
      this.locationNoneList.value = [];
      this.mapLoading.value = true;
      this.tipError.value = {};
    }
  }, {
    key: "handleInputResults",
    value: function handleInputResults(input) {
      var _this = this;
      var arr = JSON.parse(input);
      this.isMultInput.value = arr.length > 1;
      this.resetData();
      var result = arr.map(function (x, index) {
        _this.handleInput(x, index);
        return "pending";
      });
      if (this.isMultInput.value) {
        this.statusList.value = result;
      }
    }
  }, {
    key: "getLoactionAndKeywordData",
    value: function getLoactionAndKeywordData(text) {
      var arr = text.split("\n").filter(function (x) {
        return x;
      });
      var obj = {
        keyword: "",
        location: ""
      };
      arr.forEach(function (x) {
        var resultArr = x.split(":").filter(function (j) {
          return j.trim();
        });
        if (isEmpty(resultArr)) return;
        if (resultArr[0] === "keyword") {
          var _resultArr$;
          obj["keyword"] = (resultArr === null || resultArr === void 0 || (_resultArr$ = resultArr[1]) === null || _resultArr$ === void 0 ? void 0 : _resultArr$.trim()) || "";
        }
        if (resultArr[0] === "location") {
          var _resultArr$2;
          obj["location"] = (resultArr === null || resultArr === void 0 || (_resultArr$2 = resultArr[1]) === null || _resultArr$2 === void 0 ? void 0 : _resultArr$2.trim()) || "";
        }
      });
      return obj;
    }
  }, {
    key: "handleInput",
    value: function () {
      var _handleInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(input, index) {
        var _this2 = this;
        var _res$results, data, text, params, locationLatLng, _res, locationData, locationObj, res, obj, arr, value;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.mapLoading.value = true;
              _context2.next = 4;
              return this.brainClient.map.postDomainMapping(input);
            case 4:
              data = _context2.sent;
              text = get(data, "choices.[0].text", "");
              params = this.getLoactionAndKeywordData(text);
              locationLatLng = [];
              if (!(params.location === "NONE")) {
                _context2.next = 15;
                break;
              }
              _context2.next = 11;
              return NodesUtil.getLocation();
            case 11:
              _res = _context2.sent;
              if (_res === undefined) {
                params.location = "";
              } else {
                locationLatLng = [_res.lng, _res.lat];
              }
              _context2.next = 21;
              break;
            case 15:
              if (isEmpty(params.location)) {
                _context2.next = 21;
                break;
              }
              _context2.next = 18;
              return this.brainClient.map.getMapAddressGps(params.location);
            case 18:
              locationData = _context2.sent;
              locationObj = get(locationData, "results.[0].geometry.location", {
                lng: 0,
                lat: 0
              });
              locationLatLng = [locationObj.lng, locationObj.lat];
            case 21:
              _context2.next = 23;
              return this.brainClient.map.getMapTextSearch(params.keyword, locationLatLng);
            case 23:
              res = _context2.sent;
              if (!isEmpty(res.results)) {
                _context2.next = 26;
                break;
              }
              throw "\"".concat(params.keyword, "\" did not return data.");
            case 26:
              res === null || res === void 0 || (_res$results = res.results) === null || _res$results === void 0 || _res$results.forEach(function (x) {
                x.keyword = params.keyword;
              });
              if (this.isMultInput.value) {
                this.mapList.value = this.mapList.value.concat([]);
                obj = get(res, "results.[0]", {});
                this.mapList.value = [].concat(_toConsumableArray(this.mapList.value), [obj]);
              } else {
                arr = get(res, "results", []);
                this.mapList.value = arr.slice(0, 15);
              }
              setTimeout(function () {
                _this2.load();
              });
              _context2.next = 36;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](0);
              value = typeof _context2.t0 === "string" ? _context2.t0 : "Get failed " + input;
              this.tipError.value = {
                key: "error",
                value: value
              };
              console.error("error::::", _context2.t0);
            case 36:
              _context2.prev = 36;
              this.mapLoading.value = false;
              return _context2.finish(36);
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 31, 36, 39]]);
      }));
      function handleInput(_x3, _x4) {
        return _handleInput.apply(this, arguments);
      }
      return handleInput;
    }()
  }, {
    key: "getMapAddressGps",
    value: function () {
      var _getMapAddressGps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(keyword) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.brainClient.map.getMapAddressGps(keyword);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getMapAddressGps(_x5) {
        return _getMapAddressGps.apply(this, arguments);
      }
      return getMapAddressGps;
    }()
  }, {
    key: "setFitView",
    value: function setFitView(coordinates) {
      var bounds = new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]);
      var _iterator = _createForOfIteratorHelper(coordinates),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var coord = _step.value;
          bounds.extend(coord);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.map.value.fitBounds(bounds, {
        padding: 30
      });
    }
  }, {
    key: "getMapFeaturesAndLocation",
    value: function getMapFeaturesAndLocation() {
      var featureArr = [];
      var locationArr = [];
      this.mapList.value.forEach(function (address) {
        var locationObj = get(address, "geometry.location", {
          lng: 0,
          lat: 0
        });
        var locationLatLng = [locationObj.lng, locationObj.lat];
        var obj = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [locationObj.lng || 0, locationObj.lat || 0]
          },
          properties: {
            title: address.name || ""
          }
        };
        featureArr.push(obj);
        locationArr.push(locationLatLng);
      });
      return {
        features: featureArr,
        Location: locationArr
      };
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;
      if (isEmpty(this.map.value)) {
        return;
      }
      if (this.isFirstLoad.value === false) {
        this.map.value.removeLayer("points");
        this.map.value.removeSource("points");
      }
      var specificData = this.getMapFeaturesAndLocation();
      if (this.isFirstLoad.value) {
        // Add an image to use as a custom marker
        this.map.value.loadImage("".concat(settings.S3CDN).concat(settings.viewAssetsPath, "map_marker.png"), function (error, image) {
          if (error) throw error;
          _this3.map.value.addImage("custom-marker", image);
        });
      }
      this.map.value.addSource("points", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: specificData.features
        }
      });
      this.map.value.addLayer({
        id: "points",
        type: "symbol",
        source: "points",
        layout: {
          "icon-image": "custom-marker",
          "icon-size": 0.5,
          "text-field": ["get", "title"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-offset": [0, 1.25],
          "text-anchor": "top"
        }
      });
      this.isFirstLoad.value = false;
      if (specificData.Location.length > 1) {
        this.setFitView(specificData.Location);
      } else {
        this.map.value.setCenter(specificData.Location[0]);
      }
    }
  }, {
    key: "getCustomId",
    value: function getCustomId(address, id, index) {
      return get(address, "geometry.location.lng", "marker") + id + index;
    }
  }, {
    key: "getAddressDetail",
    value: function getAddressDetail(address) {
      return address.formatted_address;
    }
  }, {
    key: "zoomIn",
    value: function zoomIn(e) {
      e.stopPropagation();
      this.map.value.zoomIn({
        duration: 1000
      });
    }
  }, {
    key: "zoomOut",
    value: function zoomOut(e) {
      e.stopPropagation();
      this.map.value.zoomOut({
        offset: [80, 60]
      });
    }
  }, {
    key: "reloadLocation",
    value: function () {
      var _reloadLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this4 = this;
        var res, locationLatLng, value;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return NodesUtil.getLocation();
            case 3:
              res = _context5.sent;
              if (!(res === undefined)) {
                _context5.next = 6;
                break;
              }
              throw "User refused permission to open";
            case 6:
              locationLatLng = [res.lng, res.lat];
              this.locationNoneList.value.forEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(x) {
                  var _res$results2;
                  var res, idx, obj, arr;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return _this4.brainClient.map.getMapTextSearch(x, locationLatLng);
                      case 2:
                        res = _context4.sent;
                        res === null || res === void 0 || (_res$results2 = res.results) === null || _res$results2 === void 0 || _res$results2.forEach(function (j) {
                          j.keyword = x;
                        });
                        if (_this4.isMultInput.value) {
                          idx = _this4.mapList.value.findIndex(function (j) {
                            return j.keyword === x;
                          });
                          obj = get(res, "results.[0]", {});
                          idx === -1 ? _this4.mapList.value.push(obj) : _this4.mapList.value[idx] = obj;
                        } else {
                          arr = get(res, "results", []);
                          _this4.mapList.value = arr.slice(0, 15);
                        }
                        if (!isEmpty(_this4.mapList.value)) {
                          _context4.next = 7;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 7:
                        setTimeout(function () {
                          _this4.load();
                        });
                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x6) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context5.next = 14;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](0);
              value = typeof _context5.t0 === "string" ? _context5.t0 : "Get failed \"".concat(this.locationNoneList.value.join(","), "\"");
              this.tipError.value = {
                key: "error",
                value: value
              };
            case 14:
              _context5.prev = 14;
              if (this.tipError.value.key !== "error") {
                this.tipError.value = {};
              }
              return _context5.finish(14);
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 10, 14, 17]]);
      }));
      function reloadLocation() {
        return _reloadLocation.apply(this, arguments);
      }
      return reloadLocation;
    }()
  }]);
  return MapViewBloc;
}();